import React from "react";
import './css/home.css';


const Footer = () => {
  return(
    <footer>
      <p>Copyright ©2022 All rights reserved | CBC Hostels.</p>
    </footer>
  )
}

export default Footer;